import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-push-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/push-template/"
      channelLabel="Push"
      namePlaceholder="Enter push name"
      emptyMessage="No push found!"
      heartbeatType="push"
      [showResponsysButton]="true"
      [supportsMediaDeletion]="false"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class PushTemplateComponent {
  protected readonly templateType = TypeEnum.PUSH;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    {
      name: 'push',
      variables: {
        PushCopy: '',
        PushLink: '',
        PushSubject: '',
        PushTitle: '',
      },
    },
  ];
}
